{
  "SET_NEW_PASSWORD": {
    "TITLE": "Ustaw nowe hasło",
    "PASSWORD": {
      "LABEL": "Hasło",
      "PLACEHOLDER": "Hasło",
      "ERROR": "Hasło jest zbyt krótkie."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potwierdź hasło",
      "PLACEHOLDER": "Potwierdź hasło",
      "ERROR": "Hasła nie pasują."
    },
    "API": {
      "SUCCESS_MESSAGE": "Pomyślnie zmieniono hasło.",
      "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot. Spróbuj ponownie."
    },
    "CAPTCHA": {
      "ERROR": "Weryfikacja wygasła. Proszę rozwiązać captcha ponownie."
    },
    "SUBMIT": "Prześlij"
  }
}
